import React, { Fragment, ReactElement } from "react";
import { PlannerItemDetailProps } from "./PlannerItemDetail.types";
import { SpintrTypes } from "src/typings";
import { Conditional } from "src/components/Conditional";
import { SmallBody, SmallBodyBolder } from "src/components/Text";
import { localize } from "src/l10n";

function PlannerWorkShiftDetails({ item }: PlannerItemDetailProps): ReactElement {
    if (item.itemType !== SpintrTypes.PlannerItemType.WorkShift) {
        return null;
    }

    return (
        <Fragment>
            <Conditional condition={item.unit}>
                <div className="PlannerItemDetail-textBlock">
                    <SmallBodyBolder color="contentDark">
                        {localize("PLANNER_WORKSHIFT_UNIT")}
                    </SmallBodyBolder>
                    <SmallBody color="contentNormal" weight="regular">
                        {item.unit}
                    </SmallBody>
                </div>
            </Conditional>
        </Fragment>
    );
}

export default PlannerWorkShiftDetails;
